import axios from "axios";
import { ServiceApi } from '../../utils/auth'
import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    words: [],
    wordsCounts: []
  },
  getters: {
    words: state => state.words,
    wordsCounts: state => state.wordsCounts
  },
  mutations: {
    SET_WORDS(state, payload) {
      state.words = payload.data;
    },
    SET_WORD(state, payload) {
      state.words = payload.data;
    },
    SET_WORDS_CREATED(state, payload) {
      state.words.data.unshift(payload.data)
      state.words.total = state.words.total + 1
    },
    SET_WORDS_DELETE(state, id) {
      state.words = state.words.data.filter(item => item.id !== id)
    },
    SET_WORDS_COUNTS(state, payload) {
      state.wordsCounts = payload.data;
    }
  },
  actions: {
    async get({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await ServiceApi.get('/api/words', payload);
        commit("SET_WORDS", res.data);
        return res.data.data
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getCounts({ commit }, vm) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (vm) {
          const url = vm.search
            ? `/api/count-words?page=${vm.currentPage}&per_page=${vm.perPage}&search=${vm.search}`
            : `/api/count-words?page=${vm.currentPage}&per_page=${vm.perPage}`;
          const res = await axios.get(url);
          commit("SET_WORDS_COUNTS", res.data);
          return res.data.data;
        } else {
          const res = await axios.get("/api/count-words");
          commit("SET_WORDS_COUNTS", res.data);
          return res.data;
        }
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async show({ commit }, payload) {
      const { id } = payload;
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const resp = await axios.post(`api/words/${payload}`);
        commit("SET_WORD", resp.data);
        return resp.data;
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async createOrUpdate({ commit, dispatch }, payload) {
      const { id } = payload;
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (!payload.id) {
          const resp = await axios.post("api/words", payload);
          commit("SET_WORDS_CREATED", resp.data);
          return resp.data;
        } else {
          const res = await axios.put(`api/words/${id}`, payload);
          dispatch('get', { currentPage: 1, perPage: 10 })
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async delete({ commit, dispatch }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`/api/words/${id}`);
        dispatch('get', { currentPage: 1, perPage: 10 })
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },





  }
};
